/**
 * @module module/explore-sk
 * @description <h2><code>explore-sk</code></h2>
 *
 * Main page of Perf, for exploring data.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ExploreSk", {
    enumerable: true,
    get: function() {
        return ExploreSk;
    }
});
require("lit-html");
const _html = require("lit/html.js");
const _define = require("../../../elements-sk/modules/define");
const _stateReflector = require("../../../infra-sk/modules/stateReflector");
const _ElementSk = require("../../../infra-sk/modules/ElementSk");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
require("../explore-simple-sk");
require("../favorites-dialog-sk");
require("../test-picker-sk");
const _aloginsk = require("../../../infra-sk/modules/alogin-sk/alogin-sk");
const _errorMessage = require("../errorMessage");
const _paramtools = require("../paramtools");
require("@material/web/button/outlined-button.js");
let ExploreSk = class ExploreSk extends _ElementSk.ElementSk {
    connectedCallback() {
        super.connectedCallback();
        this._render();
        this.testPicker = this.querySelector('#test-picker');
        this.exploreSimpleSk = this.querySelector('explore-simple-sk');
        this.exploreSimpleSk.navOpen = true;
        void this.init();
        document.addEventListener('keydown', (e)=>this.exploreSimpleSk.keyDown(e));
        this.exploreSimpleSk.addEventListener('state_changed', ()=>{
            this.stateHasChanged();
        });
        this.exploreSimpleSk.addEventListener('rendered_traces', ()=>{
            this._render();
        });
        // Event listener for when the Remove All button is clicked.
        this.addEventListener('remove-explore', ()=>{
            this.exploreSimpleSk.reset();
        });
        this.addEventListener('selection-range-changed', (e)=>{
            const detail = e.detail;
            const state = this.exploreSimpleSk.state;
            if (!detail.value) {
                return;
            }
            let newBegin = detail.value.begin;
            let newEnd = detail.value.end;
            if (detail.domain === 'commit') {
                const header = this.exploreSimpleSk.getHeader();
                if (header) {
                    if (detail.start !== undefined && header[detail.start]) {
                        newBegin = header[detail.start].timestamp;
                    }
                    if (detail.end !== undefined && header[detail.end]) {
                        newEnd = header[detail.end].timestamp;
                    }
                }
            }
            state.begin = newBegin;
            state.end = newEnd;
            if (this.stateHasChanged) {
                this.stateHasChanged();
            }
        });
        (0, _aloginsk.LoggedIn)().then((status)=>{
            this.exploreSimpleSk.state.enable_favorites = status.email !== null && status.email !== '';
        }).catch(_errorMessage.errorMessage);
    }
    async init() {
        await this.initializeDefaults();
        this.stateHasChanged = (0, _stateReflector.stateReflector)(()=>this.exploreSimpleSk.state, async (hintableState)=>{
            const state = hintableState;
            this.exploreSimpleSk.openQueryByDefault = true;
            this.exploreSimpleSk.state = state;
            this.exploreSimpleSk.useTestPicker = false;
            const isV2 = window.perf.enable_v2_ui && localStorage.getItem('v2_ui') !== 'false';
            if (state.use_test_picker_query || isV2) {
                await this.initializeTestPicker();
            }
            this.exploreSimpleSk.render();
        });
    }
    /**
   * Fetches defaults from backend and passes them down to the
   * ExploreSimpleSk element.
   */ async initializeDefaults() {
        await fetch(`/_/defaults/`, {
            method: 'GET'
        }).then(_jsonOrThrow.jsonOrThrow).then((json)=>{
            this.exploreSimpleSk.defaults = json;
            this.defaults = json;
        }).catch(_errorMessage.errorMessage);
    }
    // Initialize TestPickerSk
    async initializeTestPicker() {
        var _this_defaults;
        var _this_defaults_include_params;
        const testPickerParams = (_this_defaults_include_params = (_this_defaults = this.defaults) === null || _this_defaults === void 0 ? void 0 : _this_defaults.include_params) !== null && _this_defaults_include_params !== void 0 ? _this_defaults_include_params : null;
        this.exploreSimpleSk.useTestPicker = true;
        this.testPicker.classList.remove('hidden');
        if (this.exploreSimpleSk.state.queries && this.exploreSimpleSk.state.queries.length > 0) {
            await this.testPicker.populateFieldDataFromQuery(this.exploreSimpleSk.state.queries.join('&'), testPickerParams, {});
        } else {
            var _this_defaults1;
            var _this_defaults_default_param_selections;
            await this.testPicker.initializeTestPicker(testPickerParams, (_this_defaults_default_param_selections = (_this_defaults1 = this.defaults) === null || _this_defaults1 === void 0 ? void 0 : _this_defaults1.default_param_selections) !== null && _this_defaults_default_param_selections !== void 0 ? _this_defaults_default_param_selections : {}, false);
        }
        // Event listener for when the Test Picker plot button is clicked.
        // This will create a new empty Graph at the top and plot it with the
        // selected test values.
        this.addEventListener('plot-button-clicked', async (_e)=>{
            const explore = this.exploreSimpleSk;
            if (explore) {
                const query = this.testPicker.createQueryFromFieldData();
                await explore.addFromQueryOrFormula(true, 'query', query, '');
            }
        });
        // Event listener for when the "Query Highlighted" button is clicked.
        // It will populate the Test Picker with the keys from the highlighted
        // trace.
        this.addEventListener('populate-query', async (e)=>{
            const trace_key = e.detail.key;
            await this.testPicker.populateFieldDataFromQuery((0, _paramtools.queryFromKey)(trace_key), testPickerParams, {});
            this.testPicker.scrollIntoView();
        });
    }
    constructor(){
        super(ExploreSk.template);
        this.exploreSimpleSk = null;
        this.stateHasChanged = null;
        this.defaults = null;
        this.testPicker = null;
    }
};
(()=>{
    ExploreSk.template = (_ele)=>(0, _html.html)`
    <test-picker-sk id="test-picker" class="hidden test-picker"></test-picker-sk>
    <explore-simple-sk></explore-simple-sk>
  `;
})();
(0, _define.define)('explore-sk', ExploreSk);
